import React from "react";
import { Routes, Route } from "react-router-dom";

// Importamos las páginas
import Home from "../pages/home/Home";

//Carga Hualpen
import HualpenPage from "../pages/CargaHualpen/HualpenPage";
import CargaUsersPage from "../pages/CargaHualpen/CargaUsers";
import CrearServiciosPage from "../pages/CargaHualpen/CrearServices";

// Carga Vales BancoEstado
import BcoChilePage from "../pages/ValesBcoChile/BcoChilePage";
import CargaValesPage from "../pages/ValesBcoChile/CargaVales";
import CrearServicios from "../pages/ValesBcoChile/CrearServicios";

//CERRAR SESION
import Logout from "../layout/Logout";

//TEST HOME
// import TestHome from "../pages/test/hometest";

const PanelRoutes = () => {
  return (
    <Routes>
      <Route path="Home" element={<Home />} />
      <Route path="Logout" element={<Logout />} />
      {/* Carga Hualpen  */}
      <Route path="CargaHualpen" element={<HualpenPage />} />
      <Route path="UsersHualpen/:id" element={<CargaUsersPage />} />
      <Route path="CrearServices/:id" element={<CrearServiciosPage />} />
      {/* Vales BcoChile */}
      <Route path="ValesBcoChile" element={<BcoChilePage />} />"
      <Route path="CargaVales/:id" element={<CargaValesPage />} />
      <Route path="CrearServicios/:id" element={<CrearServicios />} />
      {/* <Route path="TestHome" element={<TestHome />} /> */}
    </Routes>
  );
};

export default PanelRoutes;
